import {
  Component,
  ElementRef,
  Input,
  ViewChild,
  ChangeDetectionStrategy,
  output
} from "@angular/core";
import { ThemeService } from "src/service/theme.service";
import { ChartSerieKind } from "src/components/shared-components/enum/enumChart";
import { GenericCounterGraphData } from "../../class/generic-counter-graph-data";
import { SmartPaletteCounter } from "../../class/smart-palette";
import { CounterDistributionConsumption } from "../../class/counter-distribution-consumption";
import { SmartComponentSummaryData } from "../../class/smart-components/smart-component-property-details";
import { ChartPieData } from "../../interfaces/chart-pie-data";
import { IonIcon } from "@ionic/angular";
import { ChartLineComponent } from "../chart-line/chart-line.component";
import { ChartBarComponent } from "../chart-bar/chart-bar.component";
import { ChartPieComponent } from "../chart-pie/chart-pie.component";

@Component({
    selector: "app-widget-counter-skill-expandable",
    templateUrl: "./widget-counter-skill-expandable.component.html",
    styleUrls: [
        "./widget-counter-skill-expandable.component.scss",
        "../../styles/shared-global.scss",
    ],
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [IonIcon, ChartLineComponent, ChartBarComponent, ChartPieComponent]
})

/**
 * Counter skill expandable entry componet
 */
export class WidgetCounterSkillExpandableComponent {
  public chartSerieKind = ChartSerieKind;

  @Input() title: string = "";
  @Input() value: string = "";

  @Input() type: number = 0;
  @Input() um: string = "";
  @Input() chartAreaBarType: ChartSerieKind = ChartSerieKind.LINE;
  @Input() dataChart: GenericCounterGraphData = new GenericCounterGraphData();
  @Input() dataPieChart: (CounterDistributionConsumption | ChartPieData)[];
  @Input() dataChartCSV: string = "";
  readonly handleSwipeData = output<Date>();
  @Input() startDate: Date;
  @Input() endDate: Date;
  @Input() errorChart: boolean = false;
  @Input() smartPalette: SmartPaletteCounter = null;
  @Input() skillVisible: boolean;
  @Input() counterName: string = "";
  @Input() headerSummary: SmartComponentSummaryData = null;
  @Input() skillSummary;

  /**
   * Handle click to hide/toggle slide
   */
  public onClickToggleVisible(): void {
    this.skillVisible = !this.skillVisible;
  }

  /**
   * Handle slide for line chart
   * @param updatedDate
   */
  public handleUpdatedDate(updatedDate: Date) {
    this.handleSwipeData.emit(updatedDate);
  }
}
